<script setup lang="ts">
import type { ColorTheme } from "@/utils/bootstrap.utils";

defineProps<{
  value: number;
  animated?: boolean;
  theme?: ColorTheme;
}>();
</script>

<template>
  <div
    class="progress w-100"
    style="height: 4px"
    role="progressbar"
    aria-label="Example 1px high"
    :aria-valuenow="value"
    aria-valuemin="0"
    aria-valuemax="100"
  >
    <div
      :class="[
        'progress-bar',
        {
          'progress-bar-animated': animated,
          'progress-bar-striped': animated,
        },
        theme ? `bg-${theme}` : '',
      ]"
      :style="{ width: `${value}%` }"
    ></div>
  </div>
</template>
